import React from 'react';
import Modal from '../../components/Modal';

const PaymentErrorModal = ({ phone, onClose }) => {
  const body = (
    <div className="flex flex-col justify-center items-center text-center space-y-5 py-8">
      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-red-400 to-red-600 flex items-center justify-center shadow-lg shadow-red-500/30">
        <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
      <div>
        <h3 className="text-xl font-bold text-surface-900 mb-2">Ödəniş baş tutmadı</h3>
        <p className="text-sm text-surface-500 leading-relaxed max-w-sm">
          Kart məlumatlarınızın düzgünlüyünü və balansınızın yetərli olduğunu yoxlayın.
        </p>
      </div>
      {phone && (
        <div className="bg-surface-50 rounded-2xl px-5 py-3 text-sm text-surface-500">
          Dəstək: <strong className="text-surface-900">{phone}</strong>
        </div>
      )}
    </div>
  );

  return (
    <Modal
      title=""
      body={body}
      buttons={
        <button
          onClick={() => onClose(false)}
          type="button"
          className="w-full sm:w-auto inline-flex justify-center rounded-2xl bg-surface-900 px-6 py-3 text-sm font-semibold text-white hover:bg-surface-800 transition"
        >
          Bağla
        </button>
      }
    />
  );
};

export default PaymentErrorModal;
